<template>
  <!-- <pre v-if="responseData">  test data :: {{ responseData.data.data }}</pre> -->
  <AdminBackground v-if="smk && responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/BAJET MENGURUS.png"
        alt="BAJET MENGURUS"
        class="pbt-image"
      />
      <div class="line-under-image" />
    </div>

    <div class="content-wrapper">
      <!-- Row container for Tahun, Negeri, PBT -->
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table class="w-full text-sm text-left rtl:text-right text-black">
          <thead class="text-xl uppercase bg-gray-50">
            <tr>
              <th scope="col" class="px-6 py-3">Senarai Projek</th>
              <th scope="col" class="px-6 py-3">Peruntukan</th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white border-b border-gray-200">
              <th
                scope="row"
                class="px-6 py-4 font-medium text-black whitespace-nowrap"
              >
                Sumbangan Membantu Kadar
              </th>
              <td class="px-6 py-4 text-black">RM {{ smk.smk || "0.00" }}</td>
            </tr>
            <tr class="bg-white border-b border-gray-200">
              <th
                scope="row"
                class="px-6 py-4 font-medium text-black whitespace-nowrap"
              >
                Geran Tahunan
              </th>
              <td class="px-6 py-4 text-black">
                RM {{ smk.geran_tahunan || "0.00" }}
              </td>
            </tr>
            <tr class="bg-white">
              <th
                scope="row"
                class="px-6 py-4 font-medium text-black whitespace-nowrap"
              >
                Bil Elektrik
              </th>
              <td class="px-6 py-4 text-black">
                RM {{ smk.bil_elektrik || "0.00" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Table 1 -->
      <!-- <div class="table-container">
        <table class="budget-table">
          <thead>
            <tr>
              <th colspan="3">Sumbangan Membantu Kadar</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row-peruntukan">
              <td>Peruntukan</td>
              <td class="amount">RM {{ smk.smk }}</td>
            </tr>
          </tbody>
        </table>
      </div> -->
      <Update />
    </div>
  </AdminBackground>
  <PrimaryModule />
  <PembangunanMenu />
</template>

<script setup>
import { useHttpService } from "@/httpService";
import { onMounted, ref } from "vue";

definePage({
  alias: "/pages/pages/inspektorat/i-tegur",
  meta: {
    layout: "blank",
    public: true,
  },
});

const years = ref([]);
const states = ref(["Semua Negeri"]);
const pbt = ref([]);
const councils = ref([]);
const selectedYear = ref(2025);
const selectedsState = ref("Semua Negeri");
const selectedPbt = ref("Semua PBT");

const {
  loading,
  error,
  httpDelete,
  httpPostPut,
  httpGet,
  httpPost,
  numberWithCommas,
  formatToMillion,
} = useHttpService();

const responseData = ref(null);

const smk = ref({
  smk: {
    smk: 0,
    // eslint-disable-next-line camelcase
    geran_tahunan: 0,
    // eslint-disable-next-line camelcase
    bil_elektrik: 0,
  },
});

async function loadDataFromApi(
  year = selectedYear.value,
  state = selectedsState.value,
  pbtValue = selectedPbt.value
) {
  try {
    const plainStates = toRaw(state);
    let queryParams = `year=${year}`;

    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach((state) => {
          const stateName =
            typeof state === "string" ? state : state.name || state.value;
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`;
          }
        });
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`;
      }
    }

    if (Array.isArray(pbtValue) && !pbtValue.includes("Semua PBT")) {
      pbtValue.forEach((pbt) => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`;
      });
    }

    // const url = `pembangunan/smk?${queryParams}`

    // const response = await httpGet(url)

    const url = `https://ejkt.kpkt.gov.my/ebp1/api/pembangunan/bajet-mengurus?${queryParams}`;

    const res = await fetch(url);
    const response = await res.json();

    years.value = response.years;

    // Populate states dropdown while excluding "Modified Pbt" and null values
    states.value = ["Semua Negeri"];
    response.states.forEach((state) => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state);
      }
    });

    councils.value = response.councils;
    if (response && response.data && response.data.data) {
      responseData.value = response;

      // Access the 'data' object (assuming 'smk' is part of 'data')
      const data = response.data.data;

      smk.value = {
        smk: numberWithCommas(parseFloat(data.smk || 0).toFixed(2)),
        geran_tahunan: numberWithCommas(
          parseFloat(data.geran_tahunan || 0).toFixed(2)
        ),
        bil_elektrik: numberWithCommas(
          parseFloat(data.bil_elektrik || 0).toFixed(2)
        ),
      };
    } else {
      smk.value = {
        smk: "0.00",
        geran_tahunan: "0.00",
        bil_elektrik: "0.00",
      };
    }
  } catch (err) {
    console.error("loadDataFromApi failed:", err);
  }
}

function handleStateChange() {
  pbt.value = [];

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : [];
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : [];
  }

  // Remove "Semua Negeri" if other states are selected
  if (
    selectedsState.value.includes("Semua Negeri") &&
    selectedsState.value.length > 1
  ) {
    selectedsState.value = selectedsState.value.filter(
      (state) => state !== "Semua Negeri"
    );
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter((pbt) => pbt !== "Semua PBT");
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"];
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"];
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach((state) => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach((councilKey) => {
          const council = councils.value[state][councilKey];
          if (council && council.value) {
            pbt.value.push(council.value);
          }
        });
      }
    });
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach((state) => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach((councilKey) => {
          const council = councils.value[state][councilKey];
          if (council && council.value) {
            pbt.value.push(council.value);
          }
        });
      }
    });
  }

  console.log("Filtered PBT:", pbt.value);
}

onMounted(() => {
  loadDataFromApi();
});

//this is for setting the inital values for pbts as semua negeri id default option for Negeri (state)
watch(
  councils,
  (newValue) => {
    if (newValue) handleStateChange();
  },
  { immediate: true }
);

watch(
  [selectedYear, selectedsState, selectedPbt],
  () => {
    loadDataFromApi(
      selectedYear.value,
      selectedsState.value,
      selectedPbt.value
    );
  },
  { immediate: true }
);
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 20px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 65%);
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%;
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%;
  margin-block-start: 10px;
}

/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}

.table-container {
  margin-top: 20px;
  width: 100%;
  background: #e9e9e9;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
}

.budget-table {
  width: 100%;
  border-collapse: collapse;
}

.budget-table th {
  font-size: 1.5rem;
  font-weight: bold;
  padding: 15px;
  text-align: center;
  color: black !important;
}

.budget-table td {
  padding: 15px;
  font-size: 1.2rem;
  border-top: 1px solid #020202;
  color: black !important;
}

.row-peruntukan {
  background-color: #9ccfa8;
  text-align: center;
}

.row-perbelanjaan {
  background-color: #add8e6;
}

.amount {
  text-align: center;
  font-weight: bold;
  color: black !important;
}

/* Responsive styles */
@media (max-width: 768px) {
  .input-row {
    flex-direction: column;
    gap: 15px;
  }

  .budget-table th {
    font-size: 1.3rem;
  }

  .budget-table td {
    font-size: 1rem;
  }

  .table-container {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  .budget-table th {
    font-size: 1.1rem;
  }

  .budget-table td {
    font-size: 0.9rem;
  }

  .input-row {
    gap: 10px;
  }
}
</style>
